import { AgGridReact } from 'ag-grid-react';
import React, { useEffect, useMemo, useRef, useState } from 'react';

const HolidayReportTable = (props) => {
  const gridRef = useRef(); // Optional - for accessing Grid's API
  const [rowData, setRowData] = useState(); // Set rowData to Array of Objects, one Object per Row
  const [columnDefs, setColumnDefs] = useState();
  // DefaultColDef sets props common to all Columns
  const defaultColDef = useMemo(() => ({
    sortable: true,
  }));

  const getRowData = () => {
    const data = props.reportData?.data?.content;
    let rowData = [];
    for (let i = 0; i < data?.length; i++) {
      let currentRow = {
        srNo: i + 1 + (props.page - 1) * props.pageSize,
        employeeCode: data[i].employeeCode,
        fullName: data[i].fullName,
        utillisedHoliday: data[i].utilisedHoliday,
        holidayCountTillDate: data[i].holidayCountTillDate,
        year: data[i].year,
      };
      rowData.push(currentRow);
    }
    setRowData(rowData);
  };

  const getColumnDefs = () => {
    let columnDefs = [];
    columnDefs.push(
      { headerName: 'Sr No', field: 'srNo' },
      { headerName: 'Employee Code', field: 'employeeCode' },
      { headerName: 'Full Name', field: 'fullName' },
      { headerName: 'Utillised Holiday', field: 'utillisedHoliday' },
      { headerName: 'Total Holiday Till Today', field: 'holidayCountTillDate' },
      { headerName: 'Year', field: 'year' },
    );

    setColumnDefs(columnDefs);
  };
  // Example load data from server
  useEffect(() => {
    getRowData();
    getColumnDefs();
  }, [props.reportData]);
  return (
    <>
      <div className="ag-theme-alpine" style={{ height: 540 }}>
        <AgGridReact
          ref={gridRef} // Ref for accessing Grid's API
          rowData={rowData} // Row Data for Rows
          columnDefs={columnDefs} // Column Defs for Columns
          defaultColDef={defaultColDef} // Default Column Properties
          animateRows={true} // Optional - set to 'true' to have rows animate when sorted
          rowSelection="multiple" // Options - allows click selection of rows
          suppressExcelExport={true}
          suppressCellFocus={true}
        />
      </div>
    </>
  );
};
export default HolidayReportTable;
